import {
  Switch,
  Route,
  BrowserRouter,
  Redirect,
} from '@modern-js/runtime/router';
import loadable from '@modern-js/runtime/loadable';
import 'tailwindcss/base.css';
import 'tailwindcss/utilities.css';
import './App.less';

const AuthCenter = loadable(() => import('./pages/AuthCenter'));
const UploadMaterial = loadable(() => import('./pages/UploadMaterial'));
const JumpPage = loadable(() => import('./pages/JumpPage'));
const MessageSetting = loadable(() => import('./pages/MessageSetting'));

const App = () => (
  <BrowserRouter>
    <main id="content">
      <Switch>
        <Route path="/auth" component={AuthCenter} exact />
        <Route path="/upload" component={UploadMaterial} exact />
        <Route path="/jumper" component={JumpPage} exact />
        <Route path="/message" component={MessageSetting} exact />
        <Redirect from="/" to="/upload" />
      </Switch>
    </main>
  </BrowserRouter>
);

export default App;
